module.exports = require("./angular-chat.js");


//////////////////
// WEBPACK FOOTER
// angular-chat (bower component)
// module id = 1463
// module chunks = 0